import debounce from "debounce";

function addFavoriteProfile(id) {
    if (!this.currentUser) {
        return this.showLoginModal();
    }

    return this.updateFavoriteProfile(id);
}

function showLoginModal() {
    $('#modalNotLoggedIn').modal().show();
}

async function removeFavoriteProfile(id) {
    return this.updateFavoriteProfile(id, 1);
}

async function updateFavoriteProfile(id, remove = 0) {
    const [err, response] = await to(
        api.user.toggle_favorite_profile(remove, id)
    )

    if (err || !_.get(response, 'data.success', false)) {
        return toastr.error(_.get(this, 'translate.home.errorCommon'));
    }
    const user = _.cloneDeep(this.currentUser);
    user.favorite_profile_list = _.get(response, 'data.favorite_profile_list');
    this.store.commit('setCurrentUser', user);
}

async function getFavoriteProfiles() {
    const [err, response] = await to(
        api.user.get_favorite_profiles()
    );

    if (err || !_.get(response, 'data.success', false)) {
        return toastr.error(_.get(this, 'translate.home.errorCommon'));
    }

    return _.get(response, 'data.favorite_profiles', []);
}

const data = () => ({
    store: $store,
    debounceTime: 500,
});

export default {
    data,
    created() {
        this.updateFavoriteProfile = debounce(this.updateFavoriteProfile, this.debounceTime);
    },
    methods: {
        addFavoriteProfile,
        showLoginModal,
        removeFavoriteProfile,
        updateFavoriteProfile,
        getFavoriteProfiles,
    },
    computed: {
        ...mapState([
            'translate', 'currentUser'
        ]),
        isFavoriteProfile() {
            return _.includes(
                _.get(this, 'currentUser.favorite_profile_list', []),
                _.get(this, 'user.id', -1));
        }
    },
}
